import {Navigate, Outlet} from 'react-router-dom';
import {getLoggedInUser} from '../services/Storage';

const PrivateRoutes = () => {
    let auth = getLoggedInUser();
    return auth && auth._id ? <Outlet /> : <Navigate to="/home" />;
};

export default PrivateRoutes;
